<!--
 * @Description:: 请补充填写
 * @Version: 1.0
 * @Author: smallWhite
 * @Date: 2023-05-12 20:36:16
 * @LastEditors: smallWhite
 * @LastEditTime: 2023-05-30 14:28:32
 * @FilePath: /siana_admin/src/views/system/flagstudio/index.vue
-->
<template>
  <el-card>
    <div slot="header">
      <h2>FlagStudio配置
      </h2>
    </div>
    <el-form ref="ruleForm"
      :model="form"
      :rules="rules"
      label-width="180px"
      :label-position="phone?'top':'right'"
      class="demo-ruleForm">

      <el-form-item
        label="FlagStudio接口地址"
        prop="flagStudioUrl">
        <el-input
          v-model="form.flagStudioUrl"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        label="是否开启FlagStudio"
        prop="isOpenFlagStudio">
        <el-select
          v-model="form.isOpenFlagStudio"
          :disabled="disabled"
          style="width:100%;max-width: 600px;"
          placeholder="请选择是否开启FlagStudio">
          <el-option
            label="关闭"
            :value="0" />
          <el-option
            label="开启"
            :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item
        label="FlagStudioKey"
        prop="flagStudioKey">
        <el-input
          v-model="form.flagStudioKey"
          :disabled="disabled"
          style="width:100%;max-width: 600px;" />
      </el-form-item>
      <el-form-item
        v-if="!disabled">
        <el-button
          type="primary"
          @click="handleSubmit()">保存</el-button>
        <el-button
          @click="handleCancel()">取消</el-button>
      </el-form-item>
      <el-form-item v-else>
        <el-button
          type="primary"
          @click="disabled = !disabled">去编辑</el-button>

      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      phone: false,
      form: {
        isOpenFlagStudio: 0, // 注册模式  1 账号密码 2 邮箱注册 3 公众号
        flagStudioUrl: '', // gpt请求地址
        flagStudioKey: '' // 默认注册次数
      },
      disabled: true,
      rules: {
        isOpenFlagStudio: [{ required: false, message: '请选择是否开启FlagStudio', trigger: 'blur' }],
        flagStudioUrl: [{ required: false, message: '请输入', trigger: 'blur' }],
        flagStudioKey: [{ required: false, message: '请输入', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.phone = JSON.parse(window.localStorage.getItem('phone'))
    this.getData()
  },
  methods: {
    getData() {
      this.$https('SYSTEMSETTING', {}).then(res => {
        this.form = {
          id: res.data.id,
          isOpenFlagStudio: res.data.isOpenFlagStudio, // 注册模式  1 账号密码 2 邮箱注册 3 公众号
          flagStudioUrl: res.data.flagStudioUrl, // gpt请求地址
          flagStudioKey: res.data.flagStudioKey // stablediffusion lora地址
        }
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$https('SYSTEMEDIT', this.form).then(res => {
            if (res.status == 200) {
              this.$message.success('编辑成功！')
              this.disabled = true
            }
          })
        }
      })
    },
    handleCancel() {
      this.form = {
        id: '',
        isOpenFlagStudio: 0, // 注册模式  1 账号密码 2 邮箱注册 3 公众号
        flagStudioUrl: '', // gpt请求地址
        flagStudioKey: ''
      }
      this.getData()
      this.disabled = true
    }
  }
}
</script>

<style>
</style>
